export function formatDateToDDMMYYYY(dateInput) {
  if (!dateInput) return '';

  // Parse by splitting the string directly to avoid the Date constructor
  // treating ISO date-only strings as UTC midnight, which shifts the date
  // by one day in UTC-offset timezones.
  if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
    const [year, month, day] = dateInput.split('-');
    return `${day}-${month}-${year}`;
  }

  const date = new Date(dateInput);
  if (isNaN(date)) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
